import '../../resources/css/frame/MainHeader.scss';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { reduxForm, getFormValues } from 'redux-form';
import { Navbar, Dropdown, Nav, NavDropdown, Button, Row, Col } from 'react-bootstrap';
import {
  doChangeTimeZoneId,
  doLogout,
  forwardAccountConfig,
} from '../../actions/login/index';
import { changeAccountName } from '../../actions/login/index';
import { doGetAboutSettings, doGetAccountOperationStatusListBySessionStorage, SAVE_SETTING_ACCOUNT_DETAIL_SUCCESS } from '../../actions/settings/index';
import { doSelectSite } from '../../actions/site/index';
import { loadGroupList } from '../../actions/model/index';
import { doActivePage } from '../../actions/menu/index';
import { generateUUID } from './../common/common-data';
import {openModal, openModalAlert} from '../../actions';
import { DO_CHANGE_NAME_SUCCESS } from '../../actions/login/index';
import { doGetNotify } from '../../actions/account';
import { reGetNotifyBySession } from '../../actions/account';
import { doGetDeviceInfoByMac } from '../../actions/device';
import { doGetAccountDetail } from '../../actions/settings/index';
import moment from 'moment';
import { doSelectFloorPlanProject } from '../../actions/visual';
import webSocketService from "../../services/WebSocketService";

class MainHeader extends Component {

  constructor(props) {
    super(props);
    this.stompClient = null;
    this.state = {
      showTooltip: false,
      downlinkGroupNotifyContent: null,
      showFloorPlanPojectDropdown: false
    }

  }

  returnHome = () => {
    const { history, accountRole, doActivePage } = this.props;
    if (accountRole.flagSuperAdmin) {
      history.push(window.CONFIG.WEB_ROOT + "/site");
    } else {
      doActivePage("rf_map/project");
    }
  }

  connectWebSocket = () => {
    const { openModalAlert } = this.props;
    webSocketService.subscribe(`${window.CONFIG.SWS_SERVER_WS.subscribePrefix}/logout`, (response) => {
      const { accountInfo } = this.props;
      let body = JSON.parse(response.body);
      if (accountInfo?.account === body.username) {
        openModalAlert("You have been logged out because your account has logged in elsewhere.", undefined, this.toLogout)
      }
    })
  }


  toAccountConfig = () => {
    const { forwardAccountConfig } = this.props;
    forwardAccountConfig();
  }

  toLogout = () => {
    const { history, doLogout } = this.props;

    // to reset password page
    if (history) {
      doLogout();
      history.push(window.CONFIG.WEB_ROOT);
    }
  }

  clickNotifyIcon = () => {
    const { reGetNotifyBySession } = this.props;
    this.setState({
      showTooltip: false
    })
    reGetNotifyBySession();
  }

  convertDateTimeFormat = (dateTime, desiredFormat) => {
    const originalDate = new Date(dateTime.replace(/-/g, '/'));

    const year = originalDate.getFullYear();
    const month = String(originalDate.getMonth() + 1).padStart(2, '0');
    const day = String(originalDate.getDate()).padStart(2, '0');
    const hours = String(originalDate.getHours()).padStart(2, '0');
    const minutes = String(originalDate.getMinutes()).padStart(2, '0');
    const seconds = String(originalDate.getSeconds()).padStart(2, '0');

    const formattedDatetime = desiredFormat
      .replace('YYYY', year)
      .replace('MM', month)
      .replace('DD', day)
      .replace('HH', hours)
      .replace('mm', minutes)
      .replace('ss', seconds);

    return formattedDatetime;
  }

  fetchData = async (req, resolve, reject) => {
    try {
      const response = await fetch(req);

      if (response.ok) {
        resolve(response.json());
      } else {
        const errorData = await response.json();
        console.log("Error:", errorData);
        reject(response.json());
      }
    } catch (err) {
      console.log(err);
    }
  };

  getNotifyItemData = (resolve, reject, redirectPage, notifyMac) => {
    if (redirectPage) {
      const { selectSite, authToken } = this.props;

      let deviceFilter = 'all';
      let startTime, endTime;
      startTime = moment(new Date()).utc().subtract(10, "minutes").format('YYYY-MM-DD HH:mm:00');
      endTime = moment(new Date()).utc().format('YYYY-MM-DD HH:mm:59');

      let req = new Request(window.CONFIG.SWS_SERVER_API_URI + window.CONFIG.SWS_SERVER['user'] + '/getuserprismlist', {
        method: 'POST',
        mode: 'cors',
        headers: {
          'Authorization': authToken,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          startTime: startTime,
          endTime: endTime,
          organizationId: selectSite,
          type: '5mins',
          deviceFilter: deviceFilter,
          mac: notifyMac
        })
      });

      this.fetchData(req, resolve, reject);
    }
  }

  getAccountData = (resolve, reject, redirectPage, account) => {
    if (redirectPage) {
      const { authToken } = this.props;

      let req = new Request(window.CONFIG.SWS_SERVER_API_URI + window.CONFIG.SWS_SERVER['account'] + '/getaccountinfo', {
        method: 'POST',
        mode: 'cors',
        headers: {
          'Authorization': authToken,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          account: account
        })
      });

      this.fetchData(req, resolve, reject);
    }
  }


  selectSite = (key) => {
    const { doSelectSite, siteSummaryList, doChangeTimeZoneId, authToken, loadGroupList, location } = this.props
    doSelectSite(key, generateUUID());
    let timezoneId = siteSummaryList.filter(e => e.id === key)[0].timezone;
    doChangeTimeZoneId(timezoneId);
    // doGetNotify(key, authToken);
    if (!location.pathname.includes('/rf_map/project')) {
      loadGroupList(authToken, key ? key : -1);
    }
  }

  componentDidMount() {
    const { activePage, doGetAboutSettings, authToken, doGetAccountOperationStatusListBySessionStorage } = this.props;
    doGetAboutSettings(authToken);
    doGetAccountOperationStatusListBySessionStorage();
    if( activePage && !(activePage.includes('project') || activePage.includes('site'))) {
      this.setState({showFloorPlanPojectDropdown: true})
    }
    // here is add get setting

    this.connectWebSocket()
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { status, change, settingStatus, activePage } = this.props;
    if ((JSON.stringify(prevProps.downlinkExecuteResult) !== JSON.stringify(this.props.downlinkExecuteResult)) || (JSON.stringify(prevProps.notifyMsg) !== JSON.stringify(this.props.notifyMsg))) {
      this.setState({
        showTooltip: true
      })
    }
    if (prevProps.activePage !== activePage) {
      if(activePage.includes('project') || activePage.includes('site')){
        this.setState({ showFloorPlanPojectDropdown: false })

      } else {
        this.setState({ showFloorPlanPojectDropdown: true })
      }
    } 
    if ((prevProps.status !== status && status === DO_CHANGE_NAME_SUCCESS) || (prevProps.settingStatus !== settingStatus && settingStatus === SAVE_SETTING_ACCOUNT_DETAIL_SUCCESS)) {
      const loginParams = JSON.parse(window.sessionStorage.getItem(window.CONFIG.PROJECT_ID + window.CONFIG.WEB_CACHE_KEY.LOGIN));
      change('name', loginParams.accountInfo.name);
      change('email', loginParams.accountInfo.email);
    }
    if (
      this.props.floorPlanProjectList !== prevProps.floorPlanProjectList &&
      this.props.floorPlanProjectList &&
      this.props.floorPlanProjectList.length > 0
    ) {
      localStorage.setItem("floorPlanProjectList", JSON.stringify(this.props.floorPlanProjectList));
    }
  }

  chooseType = (type) => {
    let icon = '';

    switch (type) {
      case 'guard':
        icon = 'icon-notify-guard';
        break;

      case 'user':
        // icon = 'icon-notify-ready-to-add-user';
        icon = 'icon-notify-status-disonnected';
        break;

      default:
        icon = 'icon-notify-status-disonnected';
        break;
    }

    return icon;
  }



  renderNotify = (itemRecords, items) => {
    const newNotifyMsg = [];

    if (itemRecords && itemRecords.length !== 0) {
      itemRecords.map(item => (
        newNotifyMsg.push({
          type: item.type,
          title: item.type === 'user' ? item.clientMac : item.deviceMac,
          account: item.account ? item.account : null,
          deviceId: item.device,
          name: item.deviceName,
          message: item.msg,
          time: item.triggerDate,
          redirectPage: item.redirectPage
        })
      ))
    }

    if (items && items.length !== 0) {
      items.map(item => {
        if (item.command) {
          newNotifyMsg.push({
            type: item.type,
            title: item.name + "(" + item.mac + ")",
            message: "Setup " + item.command + " " + item.status + " for group devices in " + item.name + "(" + item.radio + ")",
            time: item.time
          })
        } else {
          newNotifyMsg.push({
            type: item.type,
            title: item.mac,
            name: item.name,
            message: item.msg,
            time: item.time
          })
        }
        return newNotifyMsg;
      })
    }
    return newNotifyMsg;
  }

  renderIcon = (parentName, icon, tooltip, action) => {
    return (
      <div className={parentName}>
        <span id="main-header-sign-out" className={icon + " margin-space"} title={tooltip} onClick={action} />
      </div>
    );
  }

  renderMenuItems = () => {
    const { siteOptions } = this.props;

    return siteOptions.map((option, index) => {
      const { filterId, selectSite } = this.props;
      let clsMenuSelection, clsTextSelection;
      if (selectSite === option.key) {
        clsMenuSelection = 'icon-menu-selection';
        clsTextSelection = 'radio-select-text';
      } else {
        clsMenuSelection = 'icon-radiobutton-none';
        clsTextSelection = 'radio-text';
      }

      return (
        <Dropdown.Item key={index} onClick={(e) => { this.selectSite(option.key) }} className='select-item' title={option.value}>
          <span className='radio-icon-area'><span id={filterId + '-radio-select-type-' + option.key} className={clsMenuSelection} /></span>
          <span className={clsTextSelection}>{option.value}</span>
        </Dropdown.Item>
      )
    });
  }

  renderProjectItems = () => {
    const {doSelectFloorPlanProject } = this.props;

    const savedData = JSON.parse(localStorage.getItem("floorPlanProjectList")) || [];

    return savedData.map((option, index) => {
      const { filterId, selectFloorPlanProject } = this.props;
      let clsMenuSelection, clsTextSelection;
      if (parseInt(selectFloorPlanProject) === option.seq) {
        clsMenuSelection = 'icon-menu-selection';
        clsTextSelection = 'radio-select-text';
      } else {
        clsMenuSelection = 'icon-radiobutton-none';
        clsTextSelection = 'radio-text';
      }

      return (
        <Dropdown.Item key={index} onClick={(e) => { doSelectFloorPlanProject(option.seq, option.environment, option.address) }} className='select-item' title={option.name}>
          <span className='radio-icon-area'><span id={filterId + '-radio-select-type-' + option.seq} className={clsMenuSelection} /></span>
          <span className={clsTextSelection}>{option.name}</span>
        </Dropdown.Item>
      )
    });
  }

  render() {
    const { authToken, forwardAccountConfig, openModal, systemVersion, formValues, selectFloorPlanProject, systemVerInfo } = this.props;

    // let siteZone = (
    //   <div className='area-site'></div>
    // );
    let projectZone = (
      <div className='area-project'></div>
    );
    let accountconfigzone = (
      <div className='area-account'></div>
    );
    if (authToken) {
      accountconfigzone = (
        <Navbar.Collapse className="justify-content-end">
          <Nav id="main-header" className="tip-zone-content">
            <NavDropdown title={
              <div>
                <span id="main-header-account-config" className="icon-account-settings margin-space" title='Account Config'></span>
              </div>
            } className="account-profile account-dropdown-style" id="account-record-content">
              <span className='icon-account-config'></span>
              <form className='account-config-form'>
                <div className='form-field-group'>
                  <Row>
                    <Col sm={12} style={{ textAlign: 'center' }}>
                      <div className='area-edit-name'>{formValues?.name}
                        <span id="main-header-edit-account" className='icon-btn-edit-n' onClick={() => openModal("accountForm", "edit", null, null)}></span>
                      </div>
                    </Col>
                    <Col sm={1}>
                    </Col>
                  </Row>
                </div>
                <div className='form-field-group'>
                  <Row>
                    <Col sm={12}>
                      <div className='account-config-form-email'>  {formValues?.email}</div>
                    </Col>
                  </Row>
                </div>
              </form>

              <NavDropdown.Divider />
              <div style={{ height: '77px', display: 'flex', alignItems: 'center' }}>
                <Button id="main-header-change-pwd" type="button" variant="primary" bsPrefix='btn btn-change-password' block onClick={() => openModal("accountConfig", "edit", null, () => forwardAccountConfig())} >Change Password</Button>
              </div>

              <NavDropdown.Divider />
              <div className='form-field-group'>
                <Row>
                  <Col sm={12}>
                    <div className='account-config-form-email'>
                      {systemVerInfo ? <span>HeatMAP v{systemVerInfo[0].parameterValue}</span> : null}
                    </div>
                  </Col>
                </Row>
              </div>
            </NavDropdown>

          </Nav>
        </Navbar.Collapse>
      );
      // if (selectSite && siteOptions && siteOptions.length > 0) {
      //   let objSelectSite = null;
      //   siteOptions.forEach(item => {
      //     if (item.key === selectSite) {
      //       objSelectSite = item;
      //     }
      //   });

      //   if (objSelectSite) {
      //     siteZone = (
      //       <div className='area-site-menu'>
      //         <span className='icon-sites-white' />
      //         <input type='hidden' id={'site-filterSearch-type'} name='searchType' value={selectSite} />
      //         <Dropdown>
      //           <Dropdown.Toggle variant="success" className='dropdown-toggle'>
      //             <label className='menu-choose-word'>{objSelectSite.value}</label>
      //             <span className='icon-btn-arrow-down-2-n' />
      //           </Dropdown.Toggle>
      //           <Dropdown.Menu flip={true}>
      //             {this.renderMenuItems()}
      //           </Dropdown.Menu>
      //         </Dropdown>
      //       </div>
      //     );
      //   }
      // }


      if (this.state.showFloorPlanPojectDropdown) {
        let objSelectSite = null;
        const savedData = JSON.parse(localStorage.getItem("floorPlanProjectList")) || [];

        savedData?.forEach(item => {
          if (item.seq === parseInt(selectFloorPlanProject)) {
            objSelectSite = item;
          }
        });
        if(objSelectSite){
        projectZone = (<div className='area-site-menu'>
          <span className='icon-sites-white' />
          <input type='hidden' id={'site-filterSearch-type'} name='searchType' value={selectFloorPlanProject} />
          <Dropdown>
            <Dropdown.Toggle variant="success" className='dropdown-toggle'>
              <label className='menu-choose-word'>{objSelectSite.name}</label>
              <span className='icon-btn-arrow-down-2-n' />
            </Dropdown.Toggle>
            <Dropdown.Menu flip={true}>
              {this.renderProjectItems()}
            </Dropdown.Menu>
          </Dropdown>
        </div>
        )}
      }
    }

    return (
      <Navbar variant="custom" style={{ padding: '0px' }}>
        <Navbar.Brand className="area-home" onClick={this.returnHome}>
          <div className='area-logo'>
            <span className="icon-logo-header"></span>
          </div>
        </Navbar.Brand>
        <div className='area-version'><label>{systemVersion ? systemVersion : ''}</label></div>
        {/* {siteZone} */}
        {projectZone}
        {accountconfigzone}
        {this.renderIcon('user-profile', 'icon-logout', 'Sign Out', this.toLogout)}
      </Navbar>
    )
  }
}
const mapStateToProps = (state, ownProps) => {
  const accountInfo = state.loginReducers.accountInfo;
  const systemInfo = state.settingsReducers.systemInfo;

  let ret = {
    authToken: state.loginReducers.authToken,
    accountInfo: accountInfo,
    accountRole: state.loginReducers.accountRole,
    // name: state.loginReducers.accountInfo ? state.loginReducers.accountInfo.name : 'Super Admin',
    downlinkExecuteResult: state.deviceReducers.downlinkExecuteResult,
    notifyMsgRecord: state.accountReducers.notifyMsgRecord,
    notifyMsg: state.commonReducers.notifyMsg,
    radioConfirm: state.deviceReducers.radioConfirm,
    vapConfirm: state.deviceReducers.vapConfirm,
    selectSite: state.siteReducers.selectSite,
    siteOptions: state.siteReducers.siteOptions,
    systemVersion: state.settingsReducers.systemVersion,
    timeZoneID: state.loginReducers.timeZoneID,
    status: state.loginReducers.status,
    siteSummaryList: state.siteReducers.siteSummaryList,
    formValues: getFormValues('AccountHeaderForm')(state),
    settingStatus: state.settingsReducers.status,
    getAPErrMsg: state.deviceReducers.errMsg,
    accountDetail: state.settingsReducers.accountDetail,
    activePage: state.menuReducers.activePage,
    selectFloorPlanProject: state.visualReducers.selectFloorPlanProject,
    floorPlanProjectList: state.visualReducers.floorPlanProjectList,
    systemInfo: systemInfo?.find(({ parameterKey }) => parameterKey === 'system.model.name').parameterValue

  }
  if (accountInfo) {
    let initialValues = {};
    initialValues['name'] = accountInfo['name'];
    initialValues['email'] = accountInfo['email'];
    ret['initialValues'] = initialValues;
  }

  if (systemInfo) {
    ret.systemVerInfo = systemInfo.filter(info => info.parameterKey === 'system.version')
  }

  return ret;
}

MainHeader = reduxForm({
  form: 'AccountHeaderForm',  // a unique identifier for this form
  destroyOnUnmount: false,
})(MainHeader)

export default withRouter(connect(
  mapStateToProps,
  {
    doLogout, forwardAccountConfig, doSelectSite, doActivePage, changeAccountName, openModal, doGetAboutSettings, doGetAccountOperationStatusListBySessionStorage,
    doChangeTimeZoneId, doGetNotify, loadGroupList, reGetNotifyBySession, doGetDeviceInfoByMac, doGetAccountDetail, doSelectFloorPlanProject, openModalAlert
  }
)(MainHeader))